var React = require('react');

function IconFilterO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M837.4 135.9c13.7 0 20-10.3 14.2-22.7l-17.2-36.4-295.5 354.5-8.2 9v326.8l10.6-25.5-115.4 115.3 61.6 25.5V440.6l-8.1-10L190.9 77l-28 58.9h674.5zM111 63.7c-13.3 0-16.6 9.2-8.9 18.6l32.9 40.3 288.4 353.7-8.1-22.8v491.4c0 13.7 7.6 17.2 17.5 7.2l44.1-44.1 115.4-115.4 10.6-10.6V458.3l-8.2 23 295.5-358.5 33.3-40.4c8.5-10.3 4.8-18.7-8.8-18.7H111z"}));
}

IconFilterO.displayName = "IconFilterO";

IconFilterO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFilterO;

IconFilterO.default = IconFilterO;
